import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { EVENT, FOOTER_COLS } from "@/data/site";
import { Overline } from "@/components/primitives";
import NewsletterForm from "@/components/forms/NewsletterForm";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-navy grain text-slate-300">
      <div className="pointer-events-none absolute -top-24 left-1/3 h-72 w-72 rounded-full bg-emerald2/15 blur-[120px]" />
      <div className="relative mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
        {/* Newsletter strip */}
        <div className="mb-14 grid gap-8 rounded-3xl border border-white/10 bg-white/[0.03] p-8 md:grid-cols-2 md:p-10">
          <div>
            <Overline light className="mb-3">Stay in the loop</Overline>
            <h3 className="font-display text-2xl font-bold text-white">Get the agenda, speaker drops and the ethanol roadmap.</h3>
            <p className="mt-2 text-sm text-slate-400">One email when it matters. No spam, unsubscribe anytime.</p>
          </div>
          <div className="flex items-center">
            <NewsletterForm dark />
          </div>
        </div>

        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src={EVENT.logo} alt="Bharat Ethanol Forum" className="h-14 w-14 object-contain" />
              <span className="font-display text-lg font-semibold text-white">Bharat Ethanol Forum</span>
            </div>
            <p className="mt-4 max-w-md text-sm text-slate-400">{EVENT.descriptor}.</p>
            <ul className="mt-5 space-y-2 text-sm">
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-emerald2" /> <span>{EVENT.address}</span></li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-emerald2" /> <a href={`mailto:${EVENT.email}`} className="hover:text-white">{EVENT.email}</a></li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0 text-emerald2" /> <span>{EVENT.phone} / {EVENT.phone2}</span></li>
            </ul>
            <div className="mt-5 flex gap-3">
              {[Linkedin, Twitter, Instagram].map((Icon, i) => (
                <a key={i} href="#" aria-label="social" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 transition-colors hover:border-emerald2 hover:text-emerald2">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-3">
            {FOOTER_COLS.map((col) => (
              <div key={col.title}>
                <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">{col.title}</h4>
                <ul className="mt-4 space-y-2.5 text-sm">
                  {col.links.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="text-slate-400 transition-colors hover:text-emerald-300">{l.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row">
          <p>© 2026 {EVENT.organiser} · Bharat Ethanol Forum. All rights reserved.</p>
          <p>Last updated: {EVENT.lastUpdated} · <Link to="/privacy" className="hover:text-slate-300">Privacy</Link> · <Link to="/terms" className="hover:text-slate-300">Terms</Link> · <Link to="/refund-policy" className="hover:text-slate-300">Refunds</Link></p>
        </div>
      </div>
    </footer>
  );
}
